import { Component } from '@angular/core';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';

export interface ILoginFormTradeProspectMessageContent {
    message?: string;
}

@Component({
    selector: 'login-form-trade-prospect-message',
    templateUrl: './login-form-trade-prospect-message.html',
    standalone: true,
    imports: [ICmsClientModule]
})
@ICmsComponent<LoginFormTradeProspectMessageBlockComponent>({
    id: 'login-form-trade-prospect-message',
    block: {
        url: 'login-form-trade-prospect-message'
    },
    onDemandOnly: true,
    name: 'Login form trade prospect message',
    fields: [
        {
            type: NICmsContentField.EFieldType.textarea,
            key: 'message',
            title: 'Trade Prospect message',
            required: true
        }
    ]
})
export class LoginFormTradeProspectMessageBlockComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    content: ILoginFormTradeProspectMessageContent;
}
